import * as React from "react";

type PublicPasswordContextType = {
    collectionResolveKey: string | null;
    collectionAccessKey: string | null;
    setCollectionResolveKey: React.Dispatch<React.SetStateAction<string | null>>;
    setCollectionAccessKey: React.Dispatch<React.SetStateAction<string | null>>;
};

const PublicCollectionAccessKeyContext = React.createContext<PublicPasswordContextType>({
    collectionResolveKey: "",
    collectionAccessKey: "",
    setCollectionResolveKey: () => {},
    setCollectionAccessKey: () => {}
});

const PublicCollectionAccessKey: React.FunctionComponent<React.PropsWithChildren<{ initialResolveKey?: string }>> = ({
    children,
    initialResolveKey = ""
}) => {
    const [collectionResolveKey, setCollectionResolveKey] = React.useState<string | null>(initialResolveKey);
    const [collectionAccessKey, setCollectionAccessKey] = React.useState<string | null>("");
    return (
        <PublicCollectionAccessKeyContext.Provider
            value={{ collectionResolveKey, setCollectionResolveKey, collectionAccessKey, setCollectionAccessKey }}
        >
            {children}
        </PublicCollectionAccessKeyContext.Provider>
    );
};

function usePublicCollectionAccessKeyContext() {
    const context = React.useContext(PublicCollectionAccessKeyContext);
    return context;
}

export { PublicCollectionAccessKey, usePublicCollectionAccessKeyContext };
